<!-- Defaults to confirm a deletion, message param is required -->
<div class="confirm-wrapper">
  <div mat-dialog-content class="content">
    <h4>{{data.title || 'Är du säker på att du vill ta bort:'}}</h4>
    @for (msg of data.message; track msg) {
      <p class="description">{{msg}}</p>
    }
  </div>
  <div mat-dialog-actions class="buttons">
    <button mat-button (click)="onCancelClick()">{{data.noBtnText || 'Avbryt'}}</button>
    <button mat-raised-button (click)="onConfirmClick()" color="{{!data.yesBtnText ? 'warn' : 'primary'}}" data-test="confirm-dialog-yes-btn">{{data.yesBtnText || 'Ta bort'}}</button>
  </div>
</div>